module.exports = __webpack_public_path__ + "static/img/BomBom.99deb7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BomBom.png
// module id = RUps
// module chunks = 10